// extracted by mini-css-extract-plugin
export default {"container":"styles-module__container__src-labstep-web-screens-Resource-Show-Center-_B8w2k styles-module__container__src-labstep-web-screens-ExperimentWorkflow-Show-Center-_P8R5_"};